export const firebaseConfig = {
  development: {
    apiKey: "AIzaSyCb5d4B7sAa8eb5TO9mIFECLWp68Q7xq4I",
    authDomain: "tipsterchat-dev.firebaseapp.com",
    databaseURL: "https://tipsterchat-dev.firebaseio.com",
    projectId: "tipsterchat-dev",
    storageBucket: "tipsterchat-dev.appspot.com",
    messagingSenderId: "584406835616",
    appId: "1:584406835616:web:ed82fafa76fa73ec57c4c5",
    measurementId: "G-5S63H2V1H7",
  },
  test: {
    apiKey: "AIzaSyCb5d4B7sAa8eb5TO9mIFECLWp68Q7xq4I",
    authDomain: "tipsterchat-dev.firebaseapp.com",
    databaseURL: "https://tipsterchat-dev.firebaseio.com",
    projectId: "tipsterchat-dev",
    storageBucket: "tipsterchat-dev.appspot.com",
    messagingSenderId: "584406835616",
    appId: "1:584406835616:web:ed82fafa76fa73ec57c4c5",
    measurementId: "G-5S63H2V1H7",
  },
  production: {
    apiKey: "AIzaSyAk0PYgK5RkxLL4Rsc00WL1xUPRahU-8J8",
    authDomain: "tipstercoins.firebaseapp.com",
    databaseURL: "https://tipstercoins.firebaseio.com",
    projectId: "tipstercoins",
    storageBucket: "tipstercoins.appspot.com",
    messagingSenderId: "552582697590",
    appId: "1:552582697590:web:ad92ec89e219c33eb68557",
    measurementId: "G-0K1L85K134",
  },
};
